import {
  DecisionSupportContextType,
  useDecisionSupportContextValues,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/DecisionSupportContext";
import { useRelatedInfrastructureIncidentPlan } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useRelatedInfrastructureIncidentPlan";
import { useInfrastructureEvent } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/hooks/useInfrastructureEvent";
import { useMemo } from "react";

export const useDecisionSupportData = (uuid: string | undefined) => {
  const {
    data: infrastructureInformationData,
    status: infrastructureInformationStatus,
  } = useInfrastructureEvent(uuid ? [uuid] : [], {
    messageContext: "DROPS_LOG",
  });

  const infrastructureEvent = infrastructureInformationData?.[0];

  const {
    data: relatedInfrastructureIncidentPlan,
    status: incidentPlanLoadingState,
  } = useRelatedInfrastructureIncidentPlan(infrastructureEvent?.incidentId);

  const {
    showAllStretches,
    setShowAllStretches,
    timeHorizonHours,
    setTimeHorizonHours,
    horizonFromTime,
    horizonToTime,
    totalAffected,
    setTotalAffected,
    affectedWithWheelchair,
    setAffectedWithWheelchair,
    isAffectedPending,
    setIsAffectedPending,
    isAffectedError,
    setIsAffectedError,
  } = useDecisionSupportContextValues();

  const contextValue = useMemo<DecisionSupportContextType>(
    () => ({
      timeHorizonHours,
      horizonFromTime,
      horizonToTime,
      totalAffected,
      setTotalAffected,
      isAffectedPending,
      setIsAffectedPending,
      isAffectedError,
      setIsAffectedError,
      setTimeHorizonHours,
      affectedWithWheelchair,
      setAffectedWithWheelchair,
    }),
    [
      timeHorizonHours,
      horizonFromTime,
      horizonToTime,
      totalAffected,
      isAffectedPending,
      isAffectedError,
      affectedWithWheelchair,
    ],
  );

  return {
    contextValue,
    infrastructureEvent,
    infrastructureInformationStatus,
    incidentPlanLoadingState,
    relatedInfrastructureIncidentPlan,
    setShowAllStretches,
    showAllStretches,
  };
};
